var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Dropdown } from "semantic-ui-react";
import { useUserActions } from "@iscr/xAppLib/Users/AdminUsers/UserActionsContext";
import { UserDisplayName } from "@iscr/xAppLib/Users/AdminUsers/Actions/UserDisplayName";
import { isPriceline } from "@iscr/views/UIelems/TenantIcon";
export function PharmacyProfileAction(_a) {
    var { content } = _a, props = __rest(_a, ["content"]);
    const { user } = useUserActions();
    if (!isPriceline(user.tenant)) {
        return null;
    }
    return (_jsx(Dropdown.Item, Object.assign({}, props, (content ? { content } : { text: "Pharmacy profile", icon: { name: "pills", color: "teal" } }), { onClick: () => app.trigger(app.events.SHOW_POPUP, {
            pt: "cx_txt",
            pn: "pharmacy-profile",
            uid: user.uid,
            txt: (_jsxs(_Fragment, { children: ["Pharmacy profile: ", _jsx(UserDisplayName, { user: user })] })),
            size: "small",
        }) })));
}
